"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filters = exports.FiltersDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var immer_1 = __importDefault(require("immer"));
var lodash_1 = require("lodash");
var nullify_1 = require("../../utils/nullify");
var use_filters_state_1 = require("../../hooks/use-filters-state");
var field_label_1 = require("../forms/field-label");
exports.FiltersDefaultProps = {
  fields: [],
  name: '',
  action: '',
  preventDefault: true,
  fieldHasValue: function (field) {
    return (0, lodash_1.isEmpty)(field.value);
  },
  onSubmit: function (state, props) {},
  onChange: function (fieldValues) {},
  labelRenderer: field_label_1.FieldLabel
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    padding-bottom: ", ";\n    gap: ", ";\n\n    a {\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n      &:focus {\n        outline: none;\n        color: ", ";\n      }\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    padding-bottom: ", ";\n    gap: ", ";\n\n    a {\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n      &:focus {\n        outline: none;\n        color: ", ";\n      }\n    }\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('text-mid'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('bold'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FieldStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    border-radius: ", ";\n    \n    &:focus-within {\n      border-color: ", ";\n    }\n\n    .shp--input-select__placeholder {\n      cursor: text;\n    }\n\n    .shp--input-select__control {\n      border-radius: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n\n    .shp--input-select__control {\n      \n    }\n\n    background-position: top right;\n    box-sizing: border-box;\n    flex-basis: 100%;\n    label, label span {\n      color: #FFF;\n    }\n\n  "], ["\n    border: 1px solid ", ";\n    border-radius: ", ";\n    \n    &:focus-within {\n      border-color: ", ";\n    }\n\n    .shp--input-select__placeholder {\n      cursor: text;\n    }\n\n    .shp--input-select__control {\n      border-radius: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n\n    .shp--input-select__control {\n      \n    }\n\n    background-position: top right;\n    box-sizing: border-box;\n    flex-basis: 100%;\n    label, label span {\n      color: #FFF;\n    }\n\n  "])), theme_1.theme.COLOR('line-filter'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-basis: 50%;\n\n    ", "\n\n  "], ["\n    flex-basis: 50%;\n\n    ", "\n\n  "])), function (_a) {
    var count = _a.count;
    return count < 2 && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex-basis: 100%;\n    "], ["\n      flex-basis: 100%;\n    "])));
  }),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-basis: calc(33.15% - ", ");\n      \n\n    &:nth-child(3n) {\n      margin-right: -", ";\n    }\n\n\n    ", "\n  "], ["\n    flex-basis: calc(33.15% - ", ");\n      \n\n    &:nth-child(3n) {\n      margin-right: -", ";\n    }\n\n\n    ", "\n  "])), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(1.5), function (_a) {
    var count = _a.count;
    return (count <= 2 || count === 4) && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      flex-basis: calc(50% - ", ");\n      \n      &:nth-child(2n) {\n        margin-right: -", ";\n      }\n\n      &:first-child {\n        flex-basis: calc(50% - ", ");\n      }\n\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n\n      ", "\n    "], ["\n      flex-basis: calc(50% - ", ");\n      \n      &:nth-child(2n) {\n        margin-right: -", ";\n      }\n\n      &:first-child {\n        flex-basis: calc(50% - ", ");\n      }\n\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n\n      ", "\n    "])), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(1.5), function (_a) {
      var count = _a.count;
      return count < 2 && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        flex-basis: 100% !important;\n      "], ["\n        flex-basis: 100% !important;\n      "])));
    });
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.form(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Field: (0, styled_components_1.default)('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles)
};
var Filters = function (props) {
  var className = props.className,
    children = props.children,
    action = props.action,
    name = props.name,
    fields = props.fields,
    onChange = props.onChange,
    labelRenderer = props.labelRenderer;
  // we'll manage the metadata (for options) at this level, rather than complicating the upper layers where metadata is not needed
  var _a = __read((0, use_filters_state_1.useFiltersState)(name), 2),
    filtersState = _a[0],
    setFiltersState = _a[1];
  var handleChange = function (_a) {
    var name = _a.name,
      value = _a.value,
      metadata = _a.metadata;
    var fieldsByName = (0, lodash_1.keyBy)(fields, function (field) {
      return field.name;
    });
    // update form field values
    var newFields = (0, immer_1.default)(fieldsByName, function (draft) {
      draft[name].value = value;
    });
    var newFilterState = (0, immer_1.default)(filtersState, function (draft) {
      draft[name] = __assign(__assign({}, draft[name] || {}), metadata || {});
    });
    setFiltersState(newFilterState);
    props.onChange((0, lodash_1.mapValues)(newFields, function (field, key) {
      return (0, nullify_1.nullify)(field.value);
    }));
  };
  var filterComponents = React.useMemo(function () {
    return (0, lodash_1.map)(fields, function (field) {
      // console.log("FILTER STATE", filterState);
      var fieldWithDefaults = __assign(__assign({
        labelRenderer: labelRenderer
      }, field), {
        value: field.value || '',
        metadata: filtersState[field.name] || {},
        valid: true,
        marginless: true
      });
      return React.createElement(My.Field, {
        count: fields.length,
        key: field.name
      }, field.render({
        field: fieldWithDefaults,
        onChange: handleChange,
        noOptionsMessage: field.noOptionsMessage
      }));
    });
  }, [fields, filtersState]);
  return React.createElement(My.Container, {
    name: name,
    method: "post",
    className: className
  }, filterComponents, children);
};
exports.Filters = Filters;
exports.Filters.defaultProps = exports.FiltersDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;